import useSelfActiveProject from './useSelfActiveProject'
import { useRecoilValue } from 'recoil'
import authAtom from 'screens/Auth/auth.atom'
import { IProject } from '../projects.types'
import selfProjectsAtom from 'screens/Auth/components/InitProvider/selfProjects.atom'
import selfTeamsAtom from 'screens/Auth/components/InitProvider/selfTeams.atom'
import useIsProjectActive from './useIsProjectActive'

const useIsJoinProjectPossible = (project: Pick<IProject, 'id' | 'eventId'>) => {


  const selfId = useRecoilValue(authAtom).user.id
  const selfProjects = useRecoilValue(selfProjectsAtom).items

  const selfTeams = useRecoilValue(selfTeamsAtom).items
  const activeTeam = selfTeams[0]

  const selfActiveProject = useSelfActiveProject()
  const isActiveProject = useIsProjectActive(project)
  const isSelfProject = selfProjects.find(sp => sp.id === project.id)

  return isActiveProject && !isSelfProject && !selfActiveProject && activeTeam?.ownerId === selfId
}

export default useIsJoinProjectPossible
